export enum PHARMACY_USER_TYPE {
  NEW = "NEW",
  REPEAT = "REPEAT",
}
